// Montessori
import React from 'react';
import Montessori from 'views/Montessori';

const Montessoripage = () => {
  return <Montessori/>;
};

export default Montessoripage;